// =====================================
//
//   Register Modal
//   Author: Gray
//   createtime: 2016 / 09 / 02
//
// =====================================

window.InifECMobileApp.directive('register', ['$rootScope', '$ngModal', '$timeout', 'UserService', 'FacebookService', '$state', '$InifECGA',
    function ($rootScope, $ngModal, $timeout, UserService, FacebookService, $state, $InifECGA) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            var nextProcess = function() {

                $scope.isParamsError = false;
                $scope.isApplyEmailError = false;
                $scope.isApplyPasswordError = false;
                $scope.isApplyRePasswordError = false;
                $scope.isConfirmPasswordError = false;

                if(!$scope.form.email || !isEmail($scope.form.email)){
                    $scope.isApplyEmailError = true;
                    $scope.isParamsError = true;
                }

                if(!$scope.form.password){
                    $scope.isApplyPasswordError = true;
                    $scope.isParamsError = true;
                }

                if(!$scope.form.repassword){
                    $scope.isApplyRePasswordError = true;
                    $scope.isParamsError = true;
                }

                if($scope.form.password != $scope.form.repassword) {
                    $scope.isConfirmPasswordError = true;
                    $scope.isParamsError = true;
                }

                if($scope.isParamsError) {
                    return
                }

                // $scope.layoutType = 'PROFILE';
                applyWithEmail();
            }

            var prevProcess = function() {

                $scope.isApplyNameError = false;
                $scope.isApplyPhoneError = false;
                $scope.isApplyInvoiceError = false;
                $scope.isApplyMobilePhoneError = false;
                $scope.isApplyAddressError = false;
                $scope.isApplyPostalError = false;
                $scope.layoutType = 'REGISTER';
            }

            // 申請會員
            var applyWithEmail = function() {

                if ($scope.isApplyWithEmail) {
                    return;
                }

                resetApplyState();

                if($scope.form.phone && !isPhone($scope.form.phone)) {
                    $scope.isApplyPhoneError = true;
                    $scope.isParamsError = true;
                }

                if($scope.form.mobilephone && !isPhone($scope.form.mobilephone)) {
                    $scope.isApplyMobilePhoneError = false;
                    $scope.isParamsError = true;
                }

                if($scope.form.postal && isNaN($scope.form.postal)) {
                    $scope.isApplyPostalError = true;
                    $scope.isParamsError = true;
                }

                if($scope.form.invoice && isNaN($scope.form.invoice)) {
                    
                    $scope.isApplyInvoiceError = true;
                    $scope.isParamsError = true;
                }

                if($scope.isParamsError) {
                    return;
                }

                $scope.isApplyWithEmail = true;
                UserService.applyAccount($scope.form.email, $scope.form.password, $scope.form.name, $scope.form.mobilephone,
                  $scope.form.phone, $scope.form.address, $scope.form.postal, $scope.form.phoneExtension, 
                  $scope.form.company, $scope.form.invoice).then(function(data) {
                    
                    $scope.isApplySuccess = true;
                    $scope.isApplyWithEmail = false;
                    $rootScope.$broadcast("OPEN_EMAIL_MESSAGE_MODAL", {
                        
                    });

                    closeModal();

                }, function(error) {
                    $scope.isApplyWithEmail = false;
                    
                    if(error && error.code === 'error.account.emailRepeat'){
                        $scope.emailExistedError = true;
                    }else if(error && error.code === 'error.account.mobilephoneRepeat'){
                        $scope.mobilephoneExistedError = true;
                    }else if(error && error.code === 'error.apply.alreadyApproved'){
                        $scope.alreadyApproved = true;
                    }else if(error && error.code === 'error.apply.applicationReviewing'){
                        $scope.applicationReviewing = true;
                    }else if(error && error.code === 'error.apply.applicationSuccess'){
                        $scope.alreadyApplyError = true;
                    }else{
                        $scope.isApplySystemError = true;
                    }

                });
            }

            var applyWithFacebook = function() {

                //Facebook登入停用
                $rootScope.$broadcast("OPEN_CONFIRM_MODAL", {
                    confirmLabel:"確定",
                    hideCancel: true,
                    title: "不再提供Facebook註冊",
                    description: "非常抱歉，本服務將不再提供 Facebook 註冊，請嘗試其他方式註冊成為會員"
                });

                // if($rootScope.useNativeLoginModal) {
                //     // window.location.href = "/nativeLogin/fblogin?url=" + $state.href($scope.backToState?$scope.backToState:$state.current.name, {}, {absolute: true});
                //     $state.go(window.STATES.NATIVE_LOGIN_MODAL, 
                //         {
                //             state: 'fblogin', 
                //             backstate: $scope.backToState?$scope.backToState:$state.current.name
                //         }
                //     ); 
                // } else {
                //     if($scope.isApplyWithFacebook){
                //         return;
                //     }

                //     resetApplyState();

                //     $scope.isApplyWithFacebook = true;

                //     FacebookService.applyWithFacebook().then(function(result){
                //         closeModal();
                //         $scope.isApplyWithFacebook = false;
                //         $rootScope.$broadcast("LOGIN_SUCCESS");

                //         $timeout(function(){
                //             const mrscid = UserService.user.mrscid;
                //             $InifECGA.eventTrack('member', 'register', mrscid);
                //             $InifECGA.eventTrack('member', 'fb_register', mrscid);
                //         },1000);
                //     }, function(error) {
                //         $scope.isApplyWithFacebook = false;
                //         $scope.fbApplyErrorMsg = error.message;
                //     });
                // }
            }

            var isPassBtn = function() {
                if($scope.form.name == '' && $scope.form.mobilephone == '' && $scope.form.phone == '' 
                    && $scope.form.address == '' && $scope.form.postal == '' && $scope.form.phoneExtension == ''
                    && $scope.form.company == '' && $scope.form.invoice == '')
                    return true;
                else 
                    return false;
            }

            var login = function() {
                
                $rootScope.$broadcast("OPEN_LOGIN_MODAL");
            }

            var openModal = function() {

                resetForm();
                resetApplyState();

                $ngModal.openModal('register-modal');
            }

            var closeModal = function() {
                $ngModal.closeModal('register-modal');
            }

            var resetForm = function() {

                $scope.form.email = '';
                $scope.form.password = '';
                $scope.form.repassword = '';
                $scope.form.name = '';
                $scope.form.mobilephone = '';
                $scope.form.phone = '';
                $scope.form.address = '';
                $scope.form.phoneExtension = '';
                $scope.form.company = '';
                $scope.form.invoice = '';
            }

            var resetApplyState = function() {

                $scope.isParamsError = false;
                // 註冊用的 whih email
                $scope.isApplyWithEmail = false;
                $scope.isApplySuccess = false;
                $scope.isApplyEmailError = false;
                $scope.isApplyPasswordError = false;
                $scope.isApplyRePasswordError = false;
                $scope.isConfirmPasswordError = false;
                $scope.isApplyNameError = false;
                $scope.isApplyPhoneError = false;
                $scope.isApplyMobilePhoneError = false;
                $scope.isApplyAddressError = false;
                $scope.isApplyPostalError = false;
                $scope.emailExistedError = false;
                $scope.mobilephoneExistedError = false;
                $scope.alreadyApproved = false;
                $scope.applicationReviewing = false;
                $scope.alreadyApplyError = false;
                $scope.isApplySystemError = false;
                $scope.isApplyInvoiceError = false;
                // 註冊用的 whih facebook
                $scope.isApplyWithFacebook = false;
                $scope.isApplyFbMemberFreeze = false;
                $scope.isApplyConnectFacebookError = false;
                // 本服務正在測試階段，請先使用電子郵件申請成為會員
                $scope.isApplySocailTest = false;
            }

            var init = function() {

            }

            /*==========================
                Events
            ==========================*/

            $scope.$on("OPEN_REGISTER_MODAL", function() {

                $scope.layoutType = 'REGISTER';

                openModal();
            });

            /*==========================
                Members
            ==========================*/

            $scope.form = {
                email: '',
                password: '',
                repassword: '',
                name: '',
                mobilephone: '',
                phone: '',
                address: '',
                postal: '',
                phoneExtension: '',
                company: '',
                invoice: '',
            };
            
            $scope.layoutType = 'REGISTER';

            $scope.isParamsError = false;
            // 註冊用的 whih email
            $scope.isApplyWithEmail = false;
            $scope.isApplySuccess = false;
            $scope.isApplyEmailError = false;
            $scope.isApplyPasswordError = false;
            $scope.isApplyRePasswordError = false;
            $scope.isConfirmPasswordError = false;
            $scope.isApplyNameError = false;
            $scope.isApplyPhoneError = false;
            $scope.isApplyMobilePhoneError = false;
            $scope.isApplyAddressError = false;
            $scope.isApplyPostalError = false;
            $scope.emailExistedError = false;
            $scope.mobilephoneExistedError = false;
            $scope.alreadyApproved = false;
            $scope.applicationReviewing = false;
            $scope.alreadyApplyError = false;
            $scope.isApplySystemError = false;
            $scope.isApplyInvoiceError = false;
            // 註冊用的 whih facebook
            $scope.isApplyWithFacebook = false;
            $scope.isApplyFbMemberFreeze = false;
            $scope.isApplyConnectFacebookError = false;
            // 本服務正在測試階段，請先使用電子郵件申請成為會員
            $scope.isApplySocailTest = false;

            /*==========================
                Methods
            ==========================*/

            $scope.login = login;
            $scope.applyWithEmail = applyWithEmail;
            $scope.applyWithFacebook = applyWithFacebook;
            $scope.nextProcess = nextProcess;
            $scope.prevProcess = prevProcess;
            $scope.isPassBtn = isPassBtn;
            
            /*==========================
                init
            ==========================*/

            init();
        }]

        _dir.restrict = "E";
        _dir.scope = true;
        _dir.templateUrl = "mobile/partials/modal/register.html";
        _dir.controller = controller;

        return _dir;
    }]
);